// extracted by mini-css-extract-plugin
export default {"ref":"Logo_ref__+ea9E","svg":"Logo_svg__Mh6+l","text":"Logo_text__606V2"};